import * as React from 'react'

const DrawDoorNew = props =>
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fillRule="nonzero" stroke={props.color} fill="none">
      <path d="M6.5 25h19M11 7h10a1 1 0 0 1 1 1v17H10V8a1 1 0 0 1 1-1Z"/>
      <path d="M19 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>
    </g>
  </svg>
export default DrawDoorNew